module.exports = __webpack_public_path__ + "static/media/windows.d7b79eca.webp";